const RUNTIME_BASE_URL = import.meta.env.VITE_BORGEE_RUNTIME_BASE_URL;
const DEV_API_TARGET = import.meta.env.VITE_E2E_API_TARGET;

function getImplicitRuntimeBaseUrl(): string {
  if (import.meta.env.DEV && DEV_API_TARGET) {
    return DEV_API_TARGET;
  }
  if (import.meta.env.DEV && window.location.port === '5173') {
    return 'http://localhost:4900';
  }
  return window.location.origin;
}

export function getBorgeeHttpBaseUrl(): string {
  return RUNTIME_BASE_URL || getImplicitRuntimeBaseUrl();
}

export function getBorgeeWsBaseUrl(): string {
  return getBorgeeHttpBaseUrl().replace(/^http/, 'ws');
}
